// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p[data-v-b045d898]{font-size:1rem}.add-new-contact[data-v-b045d898]{font-weight:600}", "",{"version":3,"sources":["webpack://./src/components/formSponsorship177/WizardStep2.vue"],"names":[],"mappings":"AACA,mBACE,cAAA,CAGF,kCACE,eAAA","sourcesContent":["\np {\n  font-size: 1rem;\n}\n\n.add-new-contact {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
